import { render, staticRenderFns } from "./AnswerScoring.vue?vue&type=template&id=049bf885&scoped=true&"
import script from "./AnswerScoring.vue?vue&type=script&lang=js&"
export * from "./AnswerScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049bf885",
  null
  
)

export default component.exports